import './search-featured-list.scss';

import { pluck, tap } from 'rxjs/operators'
import { Component, Watch } from 'vue-property-decorator';

import { map, SearchResponse } from '@skinsoft/data-store';
import { CreateReportSearchFeaturedCard } from '@skinsoft/entity-ui';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchParams } from '@skinsoft/search';
import { toSearchFeatured$ } from '@skinsoft/search-data-store/src/featured';

import { ItemDataStore, SearchResult, Wemi } from '@skinsoft/entity';
import { NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC } from '../../../../../apps/condition-report/src/busTopics';
import { SearchFeatured } from '../search-featured-card';

const SEARCH_FEATURED_ITEM_COUNT = 5;

@Component({
    components: {
        sCreateReportSearchFeaturedCard: CreateReportSearchFeaturedCard,
    },
    props: ['emptyMessage', 'title', 'targetRouteName', 'searchParams'],
    template: require('./search-featured-list.html'),
})
export class SearchFeaturedList extends ReactiveVue {
    // TODO make it generic to keep one component ?
    public emptyMessage: string;
    public searchFeatureds: SearchFeatured[] = [];
    public title: string;
    public targetRouteName: string;
    public searchParams: SearchParams;

    public $itemDataStore: ItemDataStore;

    private totalResults: number = 0;

    private subscribe() {
        const locale = this.$i18n.locale
        const sortObject =
            this.searchParams.sortType === ''
                ? null
                : { entityFields: [this.searchParams.sortType], sortAsc: this.searchParams.sortAsc };

        this.subscribeTo(
            this.$itemDataStore
                .searchAll(this.searchParams.queryText, sortObject, this.searchParams.nbResults)
                .pipe(
                    tap((result: SearchResponse<SearchResult | Wemi>) => { this.totalResults = result.totalSize }),
                    pluck<SearchResponse<SearchResult | Wemi>, SearchResult[]>('allData'),
                    map((value: SearchResult) => toSearchFeatured$(value, locale))),
            (searchFeatureds: SearchFeatured[]) => {
                this.searchFeatureds = searchFeatureds;
                this.emitOnBus(NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: searchFeatureds.length, totalResults: this.totalResults });
            },
            'searchFeatureds',
        );
    }

    private unsubscribe() {
        this.unsubscribeFrom('searchFeatureds');
    }

    @Watch('searchParams', { immediate: false, deep: true })
    private onSearchParamsChange() {
        // Testing all search params presence to avoid useless search query during params setting
        if (this.searchParams.nbResults && this.searchParams.sortType) {
            this.unsubscribe();
            this.searchFeatureds = Array(SEARCH_FEATURED_ITEM_COUNT).fill(null);
            this.$emit('totalCount', null);
            this.subscribe();
        }
    }
}
